import { render, staticRenderFns } from "./IconCustomers.vue?vue&type=template&id=6755f222"
import script from "./IconCustomers.vue?vue&type=script&lang=js"
export * from "./IconCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports